import { useMemo } from 'react';

import { useDashboardHost, useDashboardScope } from '../context/DashboardHostContext';
import type { WidgetRuntimeApi } from '../remote/WidgetRuntimeApi';
import { buildWidgetRuntimeApiFromDashboardState } from './buildWidgetRuntimeApiFromState';
import {
  useDashboardLibrarySelector,
} from './DashboardLibraryProvider';
import { useWidgetInstanceRegistry } from './instanceRegistry/WidgetInstanceRegistryProvider';
import { useDashboardRuntimeDispatchAdapter } from './useDashboardRuntimeDispatchAdapter';

/**
 * Primary hook for remote widget runtime access.
 * Reads from the isolated {@link DashboardLibraryProvider} store.
 */
export function useWidgetRuntimeApi(): WidgetRuntimeApi {
  const hostContext = useDashboardHost();
  const scope = useDashboardScope();
  const state = useDashboardLibrarySelector((libraryState) => libraryState.dashboard);
  const dispatch = useDashboardRuntimeDispatchAdapter();
  const instanceRegistry = useWidgetInstanceRegistry();

  return useMemo(
    () =>
      buildWidgetRuntimeApiFromDashboardState({
        state,
        scope,
        site: hostContext.site,
        project_id: hostContext.project_id,
        checkPermission: hostContext.checkPermission,
        dispatch,
        instanceRegistry,
      }),
    [dispatch, hostContext, instanceRegistry, scope, state]
  );
}
